<template>
  <div
    :class="['intro-tile', pageIndex === 3 ? 'intro-tile-tall': '']"
    @click="pageIndex < 3 ? pageIndex += 1 : false"
  >
    <div class="full relative" key="1">
      <transition-group
        name="custom-classes-transition"
        enter-active-class="animated fadeInRight delay-10ms"
        leave-active-class="animated fadeOutLeft delay-10ms"
        class="top relative"
        mode="out-in"
      >
        <TileContent
          text="Welcome to the<br>Regenerative Knowledge Wheel."
          :img="0"
          :key="0"
          v-show="pageIndex === 0"
        ></TileContent>
        <TileContent
          text="Spin the wheel to choose a vehicle feature."
          :img="1"
          :key="1"
          v-show="pageIndex === 1"
        ></TileContent>
        <TileContent
          text="Select which function best matches that vehicle feature."
          :img="2"
          :key="2"
          v-show="pageIndex === 2"
        ></TileContent>
        <TileContent
          text="It takes eight spins to fully regenerate!"
          :img="3"
          :key="3"
          v-show="pageIndex === 3"
        ></TileContent>
      </transition-group>
      <div class="nav-container">
        <NavBar :index="pageIndex"></NavBar>
      </div>

      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        class="top relative"
        mode="out-in"
      >
        <div class="get-started-container" v-show="pageIndex > 2">
          <div class="get-started-btn" @click="start">Get Started</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TileContent from "@/components/IntroTile/TileContent.vue";
import NavBar from "@/components/IntroTile/NavBar.vue";

export default {
  name: "intro",
  components: { TileContent, NavBar },
  data() {
    return {
      pageIndex: 0
    };
  },
  computed: {},
  methods: {
    start() {
      console.log("hi");
      this.$emit("start");
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.intro-tile {
  width: 78%;
  height: 240px;
  position: relative;
  max-width: 448px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px #0000001a;
  overflow: hidden;
  transition: all 0.5s linear 0s;
  -webkit-transition: all 0.5s linear 0s;
}

.intro-tile-tall {
  height: 325px;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
  top: 0;
  left: 0;
}
.full {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.top {
  width: 100%;
  height: 150px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.nav-container {
  width: 100%;
  height: 10%;
  margin-top: 15px;
}

.get-started-container {
  width: 100%;
  height: 40px;
  margin-top: 15px;
}

.get-started-btn {
  width: 80%;
  max-width: 235px;
  margin: 0 auto;
  background-color: rgba(0, 176, 240, 1);
  height: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-family: "VW Text";
  font-weight: normal;
  cursor: pointer;
}

.get-started-btn:hover {
  background-color: rgba(0, 176, 240, 0.8);
}

.get-started-btn:active {
  background-color: rgba(0, 176, 240, 0.5);
}
</style>

<style lang="scss" scoped>
@media (max-width: 500px) {
  .intro-tile {
    width: 78%;
    // height: 297px;
    max-height: 300px;
    max-width: 300px;
  }

  .intro-tile-tall {
    height: 60%;
    max-height: 327px;
  }
}
</style>

<style>
.delay-10ms {
  animation-delay: 10ms;
}
</style>